import { useAuth } from '../../hooks/auth';

export const Permissoes = {
  DASHBOARD_VIEW: 'dashboard.view',
  PRODUTOS_VIEW: 'produtos.view',
  PRODUTOS_CREATE: 'produtos.create',
  PRODUTOS_UPDATE: 'produtos.update',
  PRODUTOS_DELETE: 'produtos.delete',
  PEDIDOS_VIEW: 'pedidos.view',
  EMPRESA_ADMIN: 'empresa.admin',
  FILIAIS_CREATE: 'branches.create',
  USUARIOS_MANAGE: 'usuario.manage',
  API_TOKENS_MANAGE: 'api_tokens.manage',
} as const;

export type TypePermissoes = typeof Permissoes[keyof typeof Permissoes];

export function usePermissoes() {
  const { permissoes = [] } = useAuth();

  const permite = (permissao: TypePermissoes) => permissoes.includes(permissao);

  const permiteAlguma = (listaPermissoes: TypePermissoes[]) =>
    listaPermissoes.some(permissao => permissoes.includes(permissao));

  const permiteTodas = (listaPermissoes: TypePermissoes[]) =>
    listaPermissoes.every(permissao => permissoes.includes(permissao));

  return {
    permite,
    permiteAlguma,
    permiteTodas,
    Permissoes,
  };
}
